import { render, staticRenderFns } from "./EvaluationByTagVersionTable.vue?vue&type=template&id=291d3ca6&scoped=true&"
import script from "./EvaluationByTagVersionTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationByTagVersionTable.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationByTagVersionTable.vue?vue&type=style&index=0&id=291d3ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d3ca6",
  null
  
)

export default component.exports